import script from "./InfoImpressum.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoImpressum.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/InfoImpressum.css?vue&type=style&index=0&id=005d9f6a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005d9f6a"]])

export default __exports__